// Currency conversion rates (PLN to other currencies)
const CONVERSION_RATES = {
  PLN: 1.0,
  EUR: 0.25,  // 1300 PLN ≈ 325 EUR, 2500 PLN ≈ 625 EUR
  USD: 0.27,  // Approximate conversion rate
  GBP: 0.21,  // Approximate conversion rate
  CZK: 6.0,   // Approximate conversion rate
};

// Price configurations for tuning services
export const STAGE_PRICES = {
  stage1: 1300, // PLN - Fixed price for basic ECU tuning
  stage2: 2500, // PLN - Starting price for advanced tuning (variable)
};

// Convert PLN to target currency
export const convertPrice = (pricePLN, targetCurrency = 'PLN') => {
  const rate = CONVERSION_RATES[targetCurrency] || 1.0;
  return (pricePLN * rate).toFixed(2);
};

// Get currency symbol by language
export const getCurrencyByLanguage = (language) => {
  switch (language) {
    case 'en':
      return 'EUR';
    case 'de':
      return 'EUR';
    case 'cs':
      return 'CZK';
    case 'pl':
    default:
      return 'PLN';
  }
};

// Get currency symbol
export const getCurrencySymbol = (currency) => {
  const symbols = {
    PLN: 'zł',
    EUR: '€',
    USD: '$',
    GBP: '£',
    CZK: 'Kč',
  };
  return symbols[currency] || currency;
};

// Format price for display
export const formatPrice = (pricePLN, language) => {
  const currency = getCurrencyByLanguage(language);
  const symbol = getCurrencySymbol(currency);
  const convertedPrice = convertPrice(pricePLN, currency);
  return `${convertedPrice} ${symbol}`;
};
